export default {
  DASHBOARD: '/',
  DASHBOARD_FORM: '/#contactus',
  POLICY: '/policy',
  TERM: '/terms-and-conditions',
};
